const TextArea = (props) => {

  const { isLoaded } = props;

  if (!isLoaded) {
    return (
      <div className="mb-10">
        
      </div>
    );
  } else {
    return (
      <div className="mb-3 flex flex-col">
        <label
          htmlFor={props.name}
          className="block mb-1 text-sm font-regular text-text-2 focus:outline-none"
        >
          {props.title}
        </label>
        <textarea
          type={props.type}
          autoComplete={props.autocomplete}
          className={`form-control ${props.className} border-border h-auto border text-sm rounded-ctrl focus:border-primary focus:border-2 outline-0 block p-2.5`}
          id={props.name}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          onBlur={props.onBlur}
          placeholder={props.placeholder}
          rows={props.rows}
        />
      </div>
    );
  }
};

export default TextArea;